export default {
  GENERAL: 'ERROR_CODE_GENERAL',
  ROVA_DOWN: 'ROVA_ERROR',
  JOB_POSTING_REFERENCE: 'JOB_POSTING_REFERENCE_ERROR',
  FORBIDDEN: 'FORBIDDEN',
  NETWORK_ERROR: 'NETWORK_ERROR'
};
